import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-5 py-16 text-center" data-testid="payment-cancel-page">
      <Card className="w-full p-6">
        <XCircle className="mx-auto mb-3 h-12 w-12 text-muted-foreground" />
        <h1 className="text-xl font-bold">Paiement annulé</h1>
        <p className="mt-2 text-sm text-muted-foreground">Aucun montant n'a été débité. Vous pouvez réessayer quand vous voulez.</p>
        <div className="mt-5 flex justify-center gap-3">
          <Button asChild><Link to="/premium">Revoir les offres</Link></Button>
          <Button variant="outline" asChild><Link to="/">Retour au GPS</Link></Button>
        </div>
      </Card>
    </div>
  );
}
